import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import storage from 'redux-persist/lib/storage/session'

import { reducers } from "./redux";
import { sagas } from "./saga";
import persistStore from "redux-persist/es/persistStore";




const persistsConfig = {
    key: 'beconnect',
    storage,
    whitelist: ['user', 'colorMode', 'common']
}

const persistedReducer = persistReducer(persistsConfig, reducers)

const saga = createSagaMiddleware();

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(saga),
    devTools: process.env.REACT_APP_ENVIRONMENT !== 'prod',
})

saga.run(sagas);

export const persistor = persistStore(store);
export default store

